(function () {
    'use strict';

    angular.module('map')
        .controller('MapController', ['$rootScope', '$scope', 'ArcGISMap', '$timeout', mapController]);

    function mapController($rootScope, $scope, ArcGISMap, $timeout) {

        $scope.arcMap = ArcGISMap;

        $rootScope.$on('reloadTable', function () {
            $scope.arcMap.addLayerPoints();
        });

        //angular may hide some elements, so we need to reposition map
        $timeout(function () {
            if ($scope.arcMap.get()) {
                $scope.arcMap.get().reposition();
            }
        });
    }
})();
